export default "__VITE_ASSET__BeaXrchW__"